import type { ReactNode } from "react"
import {
  useMemo,
  useRef,
} from "react"
import type { VariableSizeList } from "react-window"
import { ReferencesContext } from "./ReferencesContext"

interface Props {
  children: ReactNode;
}

export function ReferencesContextProvider(props: Props) {
  const listElementRef = useRef<VariableSizeList>(null)
  const containerElementRef = useRef<HTMLDivElement>(null)

  const value = useMemo(
    () => ({
      listElementRef,
      containerElementRef,
    }),
    [
      listElementRef,
      containerElementRef,
    ],
  )

  return (
    <ReferencesContext.Provider value={value}>
      {props.children}
    </ReferencesContext.Provider>
  )
}
